// eslint-disable-next-line @typescript-eslint/ban-ts-comment
/* @ts-ignore */
import StringMask from "string-mask";

export function applyMask(
  value: string,
  mask: string,
  checkLastChar = true
): string {
  const reNotMaskValidChars = new RegExp(
    "[^" +
    mask
      .replace(/\$./g, "")
      .replace(/[^0-9AaSUL$#]/g, "")
      .replace(/[0-9#]/g, "9")
      .replace(/9+/g, "9")
      .replace(/[AaSUL]/g, "A")
      .replace(/A+/g, "A")
      .split("")
      .map((v) => (v == "9" ? "0-9" : v == "A" ? "A-Za-z" : ""))
      .join("") +
    "]",
    "g"
  );
  const valueWithoutPlaceholders = `${value}`.replace(reNotMaskValidChars, "");
  // console.log("remaking value", value, mask, valueWithoutPlaceholders);
  const ret = StringMask.apply(valueWithoutPlaceholders, mask);
  if (checkLastChar && reNotMaskValidChars.test(ret.substr(-1))) {
    /// Se ultimo caractere for placeholder não faz nada
    return value;
  }
  return ret;
}
